import { render, staticRenderFns } from "./MaddenRecap2020.vue?vue&type=template&id=2c409c52&scoped=true&"
import script from "./MaddenRecap2020.vue?vue&type=script&lang=js&"
export * from "./MaddenRecap2020.vue?vue&type=script&lang=js&"
import style0 from "./MaddenRecap2020.vue?vue&type=style&index=0&id=2c409c52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c409c52",
  null
  
)

export default component.exports